import moment from "moment";
const defDateTimeFormat = "YYYY-MM-DD HH:mm:ss";
const defDateFormat = "YYYY-MM-DD";
export const format = (date, format = defDateTimeFormat) =>
  moment(date).format(format);
export const now = (format = defDateTimeFormat) => moment().format(format);
export const today = (format = defDateFormat) => moment().format(format);
export const tomorrow = (format = defDateFormat) =>
  moment()
    .add(1, "days")
    .format(format);
export const yesterday = (format = defDateFormat) =>
  moment()
    .add(-1, "days")
    .format(format);
export const weekDay = (date = today()) => moment(date).weekday();

export const diffDate = (diff, date = today(), format = defDateFormat) =>
  moment(date)
    .add(diff, "days")
    .format(format);
export const diffMonth = (diff, date = today(), format = defDateFormat) =>
  moment(date)
    .add(diff, "months")
    .format(format);
export const diffYear = (diff, date = today(), format = defDateFormat) =>
  moment(date)
    .add(diff, "years")
    .format(format);
export const startOfMonth = (date = today(), format = defDateFormat) =>
  moment(date)
    .startOf("month")
    .format(format);
export const endOfMonth = (date = today(), format = defDateFormat) =>
  moment(date)
    .endOf("month")
    .format(format);
export const isSame = (a, b) => moment(a).isSame(b);
export const isAfter = (a, b) => moment(a).isAfter(b);
export const isBefore = (a, b) => moment(a).isBefore(b);
export const hours = () => moment().format("HH");
export const timestamp = moment().unix();
export default {
  hours,
  format,
  now,
  today,
  tomorrow,
  yesterday,
  weekDay,
  timestamp,
  diffDate,
  diffMonth,
  diffYear,
  startOfMonth,
  endOfMonth,
  isSame,
  isAfter,
  isBefore,
};
